module.exports = __webpack_public_path__ + "img/30ne.0e5f5262.svg";